//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import RepackingHistoricListView from '@/views/Warehouse/WhRepackingHistoric/list'
import RepackingHistoricCreateView from '@/views/Warehouse/WhRepackingHistoric/create'
import RepackingHistoricUpdateView from '@/views/Warehouse/WhRepackingHistoric/update'

//
export default {
    path: 'repacking_historic',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'repacking-historic',
            component: RepackingHistoricListView,
        },
        {
            path: 'create',
            name: 'repacking-historic-create',
            component: RepackingHistoricCreateView,
            meta: {
                title: 'Crear reenvasado',
            },
        },
        {
            path: ':id',
            name: 'repacking-historic-update',
            component: RepackingHistoricUpdateView,
            meta: {
                title: 'Datos de reenvasado',
            },
        },
    ],
    meta: {
        title: 'Reenvasados',
    },
}
